import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {useStartIntegrationPipedriveMutation} from "../../../store/features/integrations/integrationsService.ts";
import {PhoneHQButton, PhoneHQLoader, PhoneHQGlyph} from 'ch3-ui-lib';
import {useNavigate} from "react-router-dom";

export const PipdriveAutomation = () => {

    const [searchParams] = useSearchParams();
    const code = searchParams.get('pipedrive_code') ?? searchParams.get('code') ?? '';
    const [startIntegration, {error: integrationError}] = useStartIntegrationPipedriveMutation();
    const [result, setResult] = useState<number | undefined>(undefined);
    const [error, setError] = useState<string | null>(null);

    const startIntegrationPipedrive = async (code: string ) => {
        if (!code) {
            setError('Invalid code');
            return;
        }
        try {
            const res = await startIntegration({code});
            setResult(res?.data?.integrationId);
        } catch (e) {
            console.error(e);
        }


    }

    const navigate = useNavigate();
    useEffect(() => {

        startIntegrationPipedrive(code);
    }, [code, startIntegration]);

    useEffect(() => {
        if (integrationError && 'data' in integrationError) {
            setError((integrationError.data as Error)?.message || 'Server error occurred');
        }
    }, [integrationError]);

    return (
        <>
            {
                error && <div
                    className={'flex  justify-between  mx-auto h-full bg-danger-tint max-w-[577px] p-4 gap-1 border border-danger-ink mb-8'}>
                    <div className={'flex gap-4 items-center'}>
                        <PhoneHQGlyph name='error' size={24} className='text-red-500'/>
                        <div>
                            <p className='font-medium flex justify-between items-center'>Unexpected error</p>
                            <p className={'text-sm '}>
                                {error}
                            </p>
                        </div>

                    </div>
                    <div className='cursor-pointer' onClick={() => {
                        setError(null);
                        navigate('/admin/integrations/pipedrive');
                    }}>
                        <PhoneHQGlyph name='close' size={20}/>
                    </div>


                </div>
            }
            {!result && <div className='flex flex-col items-center  h-full'>
                <h5 className='font-semibold mb-4'>Pipedrive Integration in Progress</h5>
                <p className='mb-8'>Your Pipedrive integration is being set up. You'll be notified when it's
                    complete.</p>
                {!error &&
                    <>
                        <div className={'flex items-center h-10'}>
                            <PhoneHQLoader className={'h-10 my-5 text-brand-ink'}/>
                        </div>

                        <p> Loading...</p>
                    </>
                }
            </div>}

            {result && <div className='flex flex-col items-center  h-full'>
                <h5 className='font-semibold mb-4'>Pipedrive Integration Successful!</h5>
                <div className="max-w-[400px] mb-14 flex flex-col items-center">
                    <p >Your accounts are now connected.</p>
                        <p>You can begin using the integrated features.</p>
                    </div>
                <PhoneHQButton onClick={() => navigate(`/admin/integrations/pipedrive/settings?id=${result}`)} phq-id={`integrationPp-goToSettingsBtn`}>Go to settings</PhoneHQButton>
            </div>}
        </>

    )
}
